var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page video background"},[_c('video',{attrs:{"src":_vm.video.src,"poster":_vm.video.poster,"autoplay":"","playsinline":""},on:{"ended":_vm.onClose}})])
}
var staticRenderFns = []

export { render, staticRenderFns }